module.exports = __webpack_public_path__ + "img/qunliao.0882dbf5.png";